import "./Products.scss";
import {IDataProduct} from "./interfaces";
import {useServersStore} from "../../../../../modules/shop/servers/store";
import {Fragment, useEffect, useState} from "react";
import Product from "./components/Product/Product";
import LootboxBanner from "./components/LootboxBanner/LootboxBanner";
import GiveawayBanner from "./components/GiveawayBanner/GiveawayBanner";
import {SHOP_REDESIGN} from "../../redesign";

// Банер розіграшів стоїть у сітці на цій позиції (при 5 товарах у ряд — у другому ряду, справа)
const GIVEAWAY_BANNER_INDEX = 8;
// Банер ящика — через ряд після банера розіграшів, з лівого краю (при 5 товарах у ряд)
const BANNER_INDEX = 13;

const Products = ({dataProducts}: IDataProduct[]) => {
    const servers = useServersStore(state=> state.servers)
    const fetchServers = useServersStore(state=> state.fetchServers)

    useEffect(() => {
        fetchServers()
    }, [])

    return (
        <div className="products">
            { dataProducts.map((product, idx) => {
                return (
                    <Fragment key={product._id ?? idx}>
                        { SHOP_REDESIGN && idx === BANNER_INDEX && <LootboxBanner /> }
                        { SHOP_REDESIGN && idx === GIVEAWAY_BANNER_INDEX && <GiveawayBanner /> }
                        <Product index={idx} data={product} servers={servers} />
                    </Fragment>
                )})
            }
        </div>
    );
};

export default Products;